import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  MasterDataType,
  MasterTableDataType,
  SaveResponseType,
  SearchParamsType,
} from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { clinicId } = getConstants()
const { MastersApi } = api;
export const getMastersTableData = async (
  params: SearchParamsType
): Promise<ResponseType<{ items: MasterTableDataType[]; total: number }>> => {
  const result = await instance.post(`${MastersApi.getAllUOM}`, {
    ...params,
    clinicId,
  });
  return result.data;
};

export const deleteUOM = async (
  id:number
): Promise<ResponseType<SaveResponseType>> => {
  const result = await instance.delete(`${MastersApi.deleteUOM}${clinicId}?id=${id}`);
  return result.data;
};
export const saveMasterData = async ({params,type}: {
  params: MasterDataType | MasterDataType[];
  type: "save" | "update";
}): Promise<ResponseType<SaveResponseType>> => {
  if (type == "save") {
    const result = await instance.post(`${MastersApi.addUOM}`, params);
    return result.data;
  } else {
    const result = await instance.put(`${MastersApi.updateUOM}`, params);
    return result.data;
  }
};
